
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection1BarsCaution as ObiConnection1BarsCautionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-1-bars-caution.js';
 
 
 

 
 export const ObiConnection1BarsCaution = createComponent({
   react: React,
   tagName: 'obi-connection-1-bars-caution',
   elementClass: ObiConnection1BarsCautionElement,
   events: {
     
   }
  });
 
 